<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-col md="12" class="pa-3 d-flex flex-column" v-if="this.condition()">
    <a class="anchor" id="blocorias"></a>

    <v-card elevation="2">
      <v-card-title>{{ this.orias.libelle }}</v-card-title>
      <v-card-text>

        <a :href="`https://www.orias.fr//home/showIntermediaire/${this.orias.valeur.informationBase.siren}`" target="_blank">

          <img
              title="Entreprise radiée de l'Orias" src="../../assets/logo_orias_radie.png"
              v-if="this.orias.valeur && this.orias.valeur.informationBase.status=='Radié'"
              />

          <img
              title="Entreprise inscrite à l'Orias" src="../../assets/logo_orias.png"
              v-if="this.orias.valeur && this.orias.valeur.informationBase.status=='Inscrit'"
              />

          <img
              title="Entreprise inscrite à l'Orias" src="../../assets/logo_orias_inconnu.png"
              v-if="this.orias.valeur && this.orias.valeur.informationBase.status=='Inconnu'"
              >
        </a>
        <span v-if="this.orias_registrations==null">Aucune information disponible. Veuillez consulter le site de l'Orias</span>
        <span v-if="this.orias_registrations">
        <v-data-table
            v-if="this.orias_registrations != null"
            dense
            :headers="headers_registration"
            :items="this.orias_registrations"
            item-key="categoryName"
            class="elevation-1"
        >

          <template #item.status="{ item }">
            <br/>
            <v-chip :color="getColor(item.status)">
              {{ item.status }}
            </v-chip>
            <br/>
            <span v-if="item.deletionDate ==null">Depuis le {{ item.registrationDate }}</span>
            <span v-if="item.deletionDate">Depuis le{{ item.deletionDate }}</span>
            <br/>
            <PictoItem :data="getFondsAutorises(item.collecteFunds)"/>

            <br/>
          </template>




          <template #item.mandators="{ item }">
            <br/>
            <b v-if = "item.mandators">Mandats : <br/></b>
            <v-data-table
              v-if="item.mandators != null"
              dense
              :headers="headers_mandats"
              :items="item.mandators"
              item-key="siren"
              class="elevation-1"
              hide-default-footer
            >
             <template #item.siren="{ item }">
              <a :href="`/search/${ item.siren }?active=false`" > {{ item.siren}} </a>
             </template>
            <templte #item.bankActivites="{item}">
                <ul v-if="item.bankActivities">
              <li v-for="(activity, index) in item.bankActivities" :key="`activity-${index}`">{{ activity }}</li>
            </ul>
            </templte>

            </v-data-table>
            <br/>


            <b v-if = "item.bankActivities">Services : <br/></b>
                <ul v-if="item.bankActivities">
              <li v-for="(activity, index) in item.bankActivities" :key="`activity-${index}`">{{ activity }}</li>
            </ul>
          </template>
        </v-data-table>
          </span>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>


import PictoItem from "@/components/layout/PictoItem";

export default {
  name: "Orias",
  props: [""],
  components: {PictoItem},
  computed: {

    orias: function () {
      var orias =  this.$store.getters.getbloc("certificats", "donnees", "orias");
      return orias
    },
    orias_info: function () {
      var orias_data = this.orias.valeur
      // var etabs = this.etabs_rge
      if (orias_data != null) {
        return orias_data.informationBase
      } else {
        return null
      }
    },
    orias_registrations: function () {
      var orias_data = this.orias.valeur
      // var etabs = this.etabs_rge
      if (orias_data != null) {
        return orias_data.registrations
      } else {
        return null
      }

    },

    headers_registration() {
      return [
        {
          text: "Catégorie",
          align: "start",
          value: "categoryLabel",
          fixed: true,
          width: "100px",
        },
        {
          text: "Statut",
          value: "status",
          align: "start",
          fixed: true,
          width: "100px",
        },

        {
          text: "Mandats et services",
          value: "mandators",
          align: "start",
          fixed: true,
          width: "100px",
        },

      ];
    },

    headers_mandats() {
      return [
        {
          text: "Siren",
          align: "start",
          value: "siren",
          fixed: true,
          width: "10px",
        },
        {
          text: "Dénomination",
          value: "denomination",
          align: "start",
          fixed: true,
          width: "100px",
        },
        {
          text: "Activité bancaires",
          value: "bankActivities",
          align: "start",
          fixed: true,
          width: "100px",
        }
      ];
    },
  },

  methods: {
    condition() {
      var cond =  this.$store.getters.condition("certificats", "donnees", "orias", "valeur");
      return cond
      },
    getColor(status) {
      if (status == "INSCRIT") return 'green'
      else if (status == "SUPPRIME") return 'red'
      else return 'orange'
    },
    getFondsAutorises(fonds) {
      if (fonds) {
        return {
          "id": "actun",
          "tooltip": "Collecte de fonds autorisés",
          "icon": "mdi-currency-eur",
          "color": "green",
          "text": "Autorisé"
        }
      } else {
        return {
          "id": "actun",
          "tooltip": "Collecte de fonds interdite",
          "icon": "mdi-currency-eur-off",
          "color": "red",
          "text": "Non autorisé"
        }
      }
    }


  },
};
</script>
